export function oppositeSign(number: number): number {
  if (number === 0) {
    return number;
  }

  return number * -1;
}
